import React, { memo } from "react";
import colors from "app/colors";
import { isAudio, isImage, isPdf, isVideo } from "modules/utils/Functions";
import {
  AudioFileIcon,
  DocumentFileIcon,
  ImageFileIcon,
  PdfFileIcon,
  PowerPointFileIcon,
  SpreadsheetFileIcon,
  UnknownFileIcon,
  VideoFileIcon,
  ZipFileIcon,
} from "modules/icons";

interface IProps {
  contentType: string;
  fill?: string;
  size?: [number, number];
}

const FileTypeIcon = ({
  contentType,
  fill = colors.whiteTertiary,
  size = [86, 86],
}: IProps) => {
  const width = `${size[0]}px`;
  const height = `${size[1]}px`;

  if (isImage(contentType)) {
    return <ImageFileIcon w={width} h={height} fill={fill} />;
  }
  if (isVideo(contentType)) {
    return <VideoFileIcon w={width} h={height} fill={fill} />;
  }
  if (isAudio(contentType)) {
    return <AudioFileIcon w={width} h={height} fill={fill} />;
  }
  if (isPdf(contentType)) {
    return <PdfFileIcon w={width} h={height} fill={fill} />;
  }
  if (
    contentType.includes("application/msword") ||
    contentType.includes(
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    )
  ) {
    return <DocumentFileIcon w={width} h={height} fill={fill} />;
  }
  if (
    contentType.includes("application/vnd.ms-powerpoint") ||
    contentType.includes(
      "application/vnd.openxmlformats-officedocument.presentationml.presentation",
    )
  ) {
    return <PowerPointFileIcon w={width} h={height} fill={fill} />;
  }
  if (
    contentType.includes("application/vnd.ms-excel") ||
    contentType.includes(
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    )
  ) {
    return <SpreadsheetFileIcon w={width} h={height} fill={fill} />;
  }
  if (
    contentType.includes("application/zip") ||
    contentType.includes("application/x-zip-compressed")
  ) {
    return <ZipFileIcon w={width} h={height} fill={fill} />;
  }
  return <UnknownFileIcon w={width} h={height} fill={fill} />;
};

export default memo(FileTypeIcon);
